"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _effects = require("redux-saga/effects");

var _apiHelper = require("../api/api-helper");

var _transferServicesDataActions = require("../actions/transferServicesDataActions");

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _utilityFunctions = require("../utils/utilityFunctions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(fetchTransferServicesData);

/**
 * NOTE: This request is mainly for flight segment validation.
 *
 * We get all the transport services from the booking services.
 * Cancelled and expired are ignored.
 *
 * But we only handle if there is only 1 transfer service on the booking services.
 * If there is more we offload it to flight form submit.
 * */
function fetchTransferServicesData() {
    var authToken, locale, services, transferServices, numOfTransfers, response, transferServiceData, productId, transportResponse, transportData, _getTransportDirectio, isArrival, isDeparture;

    return _regenerator2.default.wrap(function fetchTransferServicesData$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    if (!true) {
                        _context.next = 50;
                        break;
                    }

                    _context.next = 3;
                    return (0, _effects.take)(_transferServicesDataActions.TRANSFER_SERVICES_DATA_REQUESTED);

                case 3:
                    _context.next = 5;
                    return (0, _effects.select)(function (state) {
                        return state.user.authorization.token;
                    });

                case 5:
                    authToken = _context.sent;
                    _context.next = 8;
                    return (0, _effects.select)(function (state) {
                        return state.intl.locale;
                    });

                case 8:
                    locale = _context.sent;
                    _context.next = 11;
                    return (0, _effects.select)(function (state) {
                        return state.bookingServices;
                    });

                case 11:
                    services = _context.sent;

                    // Pick only valid transport transfers and order them by date
                    transferServices = services.filter(function (service) {
                        return service.status !== "Expired" && service.status !== "Cancelled" && service.type === "transport_services" && service.sub_type === "Transfer";
                    });

                    // If there is no transfers or more than one transfer then we skip the pre-request.
                    // Because the validation becomes more complex since we need to verify
                    // which customer is on that transfer and then do the check on the applicable transfers.
                    // Therefore, it should happen on flight form submit rather.

                    numOfTransfers = transferServices.length;

                    if (numOfTransfers) {
                        _context.next = 18;
                        break;
                    }

                    _context.next = 17;
                    return (0, _effects.put)((0, _transferServicesDataActions.transferServicesDataReceived)({ transfers: [], arrival: null, departure: null }));

                case 17:
                    return _context.abrupt("continue", 0);

                case 18:
                    if (!(numOfTransfers > 1)) {
                        _context.next = 22;
                        break;
                    }

                    _context.next = 21;
                    return (0, _effects.put)((0, _transferServicesDataActions.transferServicesDataReceived)({ transfers: transferServices, arrival: null, departure: null }));

                case 21:
                    return _context.abrupt("continue", 0);

                case 22:
                    _context.next = 24;
                    return (0, _apiHelper.getTransferServiceData)(transferServices[0].id, authToken, locale);

                case 24:
                    response = _context.sent;
                    transferServiceData = response && response.transferServiceData;

                    if (transferServiceData) {
                        _context.next = 30;
                        break;
                    }

                    _context.next = 29;
                    return (0, _effects.put)((0, _transferServicesDataActions.transferServicesDataRequestFailed)(response && response.error));

                case 29:
                    return _context.abrupt("continue", 0);

                case 30:
                    productId = _lodash2.default.get(transferServiceData, "product.id", null);

                    if (productId) {
                        _context.next = 35;
                        break;
                    }

                    _context.next = 34;
                    return (0, _effects.put)((0, _transferServicesDataActions.transferServicesDataRequestFailed)({ message: "Missing product id on transport service data" }));

                case 34:
                    return _context.abrupt("continue", 0);

                case 35:
                    _context.next = 37;
                    return (0, _apiHelper.getTransportData)(productId, authToken, locale);

                case 37:
                    transportResponse = _context.sent;
                    transportData = transportResponse && transportResponse.transportData;

                    if (transportData) {
                        _context.next = 43;
                        break;
                    }

                    _context.next = 42;
                    return (0, _effects.put)((0, _transferServicesDataActions.transferServicesDataRequestFailed)(transportResponse && transportResponse.error));

                case 42:
                    return _context.abrupt("continue", 0);

                case 43:
                    _getTransportDirectio = (0, _utilityFunctions.getTransportDirection)(transportData), isArrival = _getTransportDirectio.isArrival, isDeparture = _getTransportDirectio.isDeparture;

                    if (!(!isArrival && !isDeparture)) {
                        _context.next = 46;
                        break;
                    }

                    return _context.abrupt("continue", 0);

                case 46:
                    _context.next = 48;
                    return (0, _effects.put)((0, _transferServicesDataActions.transferServicesDataReceived)(isDeparture ? { transfers: [], arrival: null, departure: transferServiceData } : { transfers: [], arrival: transferServiceData, departure: null }));

                case 48:
                    _context.next = 0;
                    break;

                case 50:
                case "end":
                    return _context.stop();
            }
        }
    }, _marked, this);
}

exports.default = fetchTransferServicesData;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./app/sagas/fetchTransferServicesData.js
// module id = 1418
// module chunks = 0